import { render, staticRenderFns } from "./PostViewForm.vue?vue&type=template&id=f7774e18&"
import script from "./PostViewForm.vue?vue&type=script&lang=js&"
export * from "./PostViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports